var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('InlineSvg',{staticClass:"svg-icon",class:{ active: _vm.active },attrs:{"src":_vm.src,"width":_vm.width,"height":_vm.height}})}
var staticRenderFns = []

export { render, staticRenderFns }